import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FAV_KEY = "as_auto_favorites";
const FavoritesContext = createContext(null);
export const useFavorites = () => useContext(FavoritesContext);

const readLocal = () => {
  try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); } catch { return []; }
};

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(readLocal);

  useEffect(() => {
    if (user && user !== false) {
      const local = readLocal();
      api
        .post("/me/favorites/sync", { vehicle_ids: local })
        .then((r) => {
          setIds(r.data.favorites || []);
          localStorage.removeItem(FAV_KEY);
        })
        .catch(() => {});
    } else if (user === false) {
      setIds(readLocal());
    }
  }, [user]);

  const isFavorite = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback(
    (id) => {
      const has = ids.includes(id);
      const next = has ? ids.filter((x) => x !== id) : [...ids, id];
      setIds(next);
      if (user && user !== false) {
        if (has) api.delete(`/me/favorites/${id}`).catch(() => {});
        else api.post(`/me/favorites`, { vehicle_id: id }).catch(() => {});
      } else {
        localStorage.setItem(FAV_KEY, JSON.stringify(next));
      }
    },
    [ids, user]
  );

  return (
    <FavoritesContext.Provider value={{ ids, count: ids.length, isFavorite, toggle }}>
      {children}
    </FavoritesContext.Provider>
  );
}
